import React from 'react';
import { Home, Compass, Calendar, User } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import useKeyboardOpen from '../../hooks/useKeyboardOpen';

const MinimalBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { open: kbOpen } = useKeyboardOpen();

  const navItems = [
    { icon: Home, path: '/home-minimal', label: 'Home' },
    { icon: Compass, path: '/my-domains', label: 'Domains' },
    { icon: Calendar, path: '/timeline', label: 'Timeline' },
    { icon: User, path: '/profile-new', label: 'Profile' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <div
      aria-hidden={kbOpen}
      data-testid="minimal-bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-stone-200"
      style={{
        transform: kbOpen ? 'translateY(110%)' : 'translateY(0)',
        opacity: kbOpen ? 0 : 1,
        pointerEvents: kbOpen ? 'none' : 'auto',
        transition: 'transform 220ms ease-out, opacity 180ms ease-out',
        willChange: 'transform',
      }}
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-around h-16">
          {navItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.path);
            
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="relative flex flex-col items-center justify-center w-16 h-16 group"
              >
                <Icon 
                  className={`w-6 h-6 transition-colors ${
                    active ? 'text-cosmic-600' : 'text-stone-400 group-hover:text-stone-600'
                  }`}
                />
                {active && (
                  <div className="absolute bottom-0 w-1 h-1 bg-cosmic-600 rounded-full" />
                )}
                
                {/* Tooltip */}
                <span className="absolute -top-8 bg-stone-900 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                  {item.label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default MinimalBottomNav;